var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 105,
    viewBox: "0 0 96 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 96H39.0556L28.5 85.5181L19 71.8916L9.5 51.9759V27.8675L28.5 9H66.5L85.5 27.8675V51.9759L76 71.8916L66.5 85.5181L57 96Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0009 9.54422H28.9989V0H67.0009V9.54422ZM76.4991 19.0884H67.0009V9.54422H76.4991V19.0884ZM85.9973 28.6371H76.4991V19.0884H85.9973V28.6371ZM85.9973 52.4999V28.6371H95.5V52.4999H85.9973ZM76.4991 71.593V52.4999H85.9973V71.593H76.4991ZM67.0009 85.9116V71.593H76.4991V85.9116H67.0009ZM57.4982 95.4558V85.9116H67.0009V95.4558H57.4982ZM38.5018 95.4558H57.4982V105H38.5018V95.4558ZM28.9991 85.9116H38.5018V95.4558H28.9991V85.9116ZM19.5009 71.593H28.9991V85.9116H19.5009V71.593ZM10.0027 52.4999H19.5009V71.593H10.0027V52.4999ZM10.0027 28.6371V52.4999H0.5V28.6371H10.0027ZM19.5009 19.0884V28.6371H10.0027V19.0884H19.5009ZM19.5009 19.0884H28.9991L28.9989 9.54422H19.5009V19.0884ZM28.9991 47.7257V28.6372H38.5018V47.7257H28.9991ZM57.4983 47.7257V57.2743H38.5019L38.5018 47.7257H57.4983ZM57.4983 28.6372H38.5018L38.5019 19.0885H57.4983V28.6372ZM57.4983 28.6372V47.7257H67.001V28.6372H57.4983Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.54b19d11064630f02d1354bc47828e23.svg";
export { ForwardRef as ReactComponent };